import useSWR from 'swr';
import fetchDataService from '../services/fetchDataService';

export function useTemplates(tokenData:any, requestData:any){
  const {company} = requestData;
  const url = '/manufacturing/get-templates';
  const fetcher = () => fetchDataService.post(url, tokenData.key, {...requestData, csrfToken: tokenData?.token?.uid});
  const {data, error, isLoading} = useSWR(
    ()=>(tokenData?.key && company) ? [url, tokenData.token.uid] : null, 
    fetcher, 
    {keepPreviousData:true}
  );
  return {
    data,
    error,
    isLoading
  }
}

export function useTemplate(tokenData:any, requestData:any){
  const {template_uid, company_uid} = requestData;
  const url = '/manufacturing/get-template';
  const fetcher = () => fetchDataService.post(url, tokenData.key, {...requestData, csrfToken: tokenData?.token?.uid});
  const {data, error, isLoading} = useSWR(
    ()=>(tokenData?.key && template_uid) ? [`${url}/${template_uid}`, company_uid, tokenData.token.uid] : null, 
    fetcher
  );
  return {
    data,
    error,
    isLoading
  }
}

export function useOrders(tokenData:any, requestData:any){
  const {company} = requestData;
  const url = '/manufacturing/get-orders';
  const fetcher = () => fetchDataService.post(url, tokenData.key, {...requestData, csrfToken: tokenData?.token?.uid});
  const {data, error, isLoading} = useSWR(
    ()=>(tokenData?.key && company) ? [url, tokenData.token.uid] : null, 
    fetcher, 
    {keepPreviousData:true}
  );
  return {
    data,
    error,
    isLoading
  }
}

export function useOrder(tokenData:any, requestData:any){
  const {order_uid, company_uid} = requestData;
  const url = '/manufacturing/get-order';
  const fetcher = () => fetchDataService.post(url, tokenData.key, {...requestData, csrfToken: tokenData?.token?.uid});
  const {data, error, isLoading,mutate} = useSWR(
    ()=>(tokenData?.key && order_uid) ? [`${url}/${order_uid}`, company_uid, tokenData.token.uid] : null, 
    fetcher
  );
  return {
    data,
    error,
    mutate,
    isLoading
  }
}
